import { createContext, useContext } from 'react';
import { LmBatchFile } from '../../../types/opm-pd-lm-types';

type Policy = LmBatchFile['policies'][number] & {
  _index: number;
  _otherQualifiedAgent: string;
  _otherQualifiedAgentName: string;
  _policyTaskStatusLabel: string;
};

export type PoliciesApprovalRequestPageContextType = {
  lmBatchFile: LmBatchFile | null;
  lmBatchFileLoading: boolean;
  isSubmitting: boolean;
  policies: Policy[];
  selectedPolicyIds: string[];
  validPolicyIds: string[];
  setSelectedPolicyIds: React.Dispatch<React.SetStateAction<string[]>>;
  approvePolicies: () => void;
  rejectPolicies: () => void;
  sendBackPolicies: () => void;
};

export const PoliciesApprovalRequestPageContext = createContext<PoliciesApprovalRequestPageContextType>({
  lmBatchFile: null,
  lmBatchFileLoading: false,
  isSubmitting: false,
  policies: [],
  selectedPolicyIds: [],
  validPolicyIds: [],
  setSelectedPolicyIds: () => {},
  approvePolicies: async () => {},
  rejectPolicies: async () => {},
  sendBackPolicies: async () => {},
});

export const usePoliciesApprovalRequestPageContext = (): PoliciesApprovalRequestPageContextType => {
  const context = useContext(PoliciesApprovalRequestPageContext);
  if (!context) {
    throw new Error(
      'usePoliciesApprovalRequestPageContext must be used within a PoliciesApprovalRequestPageContext.Provider',
    );
  }
  return context;
};
